import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateIsNotEmpty } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Magic Patterns",
  category: AgentCategory.DESIGN,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#7DD382",
  helpUrl: "https://help.dartai.com/en/articles/11424376-ai-design-agent",
  description: "Generate polished UI prototypes and design-system-aware components from a prompt",
  descriptionMarkdown: `## Overview

Integrate Dart with Magic Patterns to streamline UI/UX design and development workflows. This integration enables automated task creation for design reviews, prototype testing, and development handoffs while maintaining design consistency across your product team.

The integration connects Magic Patterns' AI prototyping capabilities with Dart's project management, automatically creating tasks for design iterations, stakeholder reviews, and developer implementation based on your design system requirements and project timelines.

## Features

- AI-powered UI component generation from simple text descriptions and requirements
- Consistent design systems with automated style guide generation and maintenance
- Interactive prototype creation with real data integration and user testing capabilities
- Clean code export in React, Vue, Angular, or vanilla HTML/CSS/JavaScript
- Automated design review workflows with stakeholder feedback collection
- Design-to-development handoff with specifications and asset generation

## Setup guide

1. Create or use existing Magic Patterns account
2. Generate your API token from Magic Patterns tokens page
3. Navigate to Dart agents page
4. Paste your API token in respective field
5. Assign design tasks to your Magic Patterns agent in any accessible dartboard`,

  configFields: [
    {
      type: "password",
      key: "apiKey",
      label: "API token",
      placeholder: "Your Magic Patterns API token",
      validate: validateIsNotEmpty,
    },
  ],
};

export default config;
